import { ILineDrawable, instanceOfILineDrawable } from "../../../../base/domain/drawing";
import { IPrintBehaviorSpecifiable, instanceOfIPrintBehaviorSpecifiable } from "../../../../documaker/domain/format/objects";
import { IVectorCoordinatableObject, instanceOfIVectorCoordinatableObject } from "./IVectorCoordinatableObject";

export interface ILineObject extends IVectorCoordinatableObject, IPrintBehaviorSpecifiable, ILineDrawable {}

export function instanceOfILineObject(instance: any): instance is ILineObject {
  return instance
      && instanceOfILineDrawable(instance)
      && instanceOfIPrintBehaviorSpecifiable(instance)
      && instanceOfIVectorCoordinatableObject<ILineObject>(instance, "line");
}
